<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Spring Circles</h2>
        <!-- <h3>Reformer Springs for a Classical Experience</h3> -->

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="contrology-spring-circle-2band@1x.png"
              src2="contrology-spring-circle-2band@2x.png"
              alt="Photo of Contrology Spring Circle"
              caption="2-band Circle"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-spring-circle-3band@1x.png"
              src2="contrology-spring-circle-3band@2x.png"
              alt="Photo of Contrology Spring Circle"
              caption="3-band Circle"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-spring-circle-4band@1x.png"
              src2="contrology-spring-circle-4band@2x.png"
              alt="Photo of Contrology Spring Circle"
              caption="4-band Circle"
            />
          </photo-grid>

          <div class="content-wrapper">
            <section class="intro">
              <h2>Spring Circles</h2>
              <!-- <h3>Reformer Springs for a Classical Experience</h3> -->
              <p>
                Faithful reproductions of Joseph Pilates’ Magic Circles. These Pilates rings are made from tempered spring steel with padded wooden handles. Challenge yourself to do the classical Pilates exercises with the added resistance, and weight, of a metal Spring Circle.
                <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span>
              </p>
              <div v-show="show">
                <p>
                  Balanced Body Spring Circles are 16.5″ (42cm) diameter (from handle to handle) and feature 2, 3 or 4 spring steel bands. The greater the number of metal “bands”, the stronger the resistance and the heavier the Spring Circle.
                </p>
                <!-- <p>
                  To get these springs right, we worked with some of the most experienced and brightest minds in the Classical world including Jay Grimes, Karen Frischmann and Sandy Shimoda. We are builders, informed by users who trace back to Joe’s studio.
                </p> -->
                <p>
                  Volume discounts are available on this item for quantities of 10 or more. Please <a href="https://www.pilates.com/store/contact-us" style="text-decoration: underline">call to order</a> for discount.
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
            />

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >90-Day Limited Warranty</icon-link>
              <icon-link
                url="support"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
            </section>

            <img class="resistance-image" src="https://s3.amazonaws.com/s3.pilates.com/img/store/accessories/rings/bb-rings-comparison@1x.png" srcset="https://s3.amazonaws.com/s3.pilates.com/img/store/accessories/rings/bb-rings-comparison@2x.png 2x" alt="Circle Spring resistance chart">

            <section class="more">
              <p style="font-size:0.9375rem">For modern lightweight versions of Joe's traditional Circles, check out:</p>
              <tertiary-button text="Ultra-Fit Circle" url="https://www.pilates.com/store/accessories/rings-circles/ultra-fit-circle" style="min-width: 122.5px" />
              <tertiary-button text="Ultra-Fit Circle Mini" url="https://www.pilates.com/store/accessories/rings-circles/ultra-fit-circle-mini" />
            </section>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
// import CtaProdButton from "@/components/CtaProdButton.vue";
import TertiaryButton from "@/components/TertiaryButton.vue";

export default {
  name: "springcircles",

  metaInfo: {
    title: "Pilates Magic Circle - Pilates Rings - Contrology Spring Circles",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Want an authentic Pilates Magic Circle? These Contrology Pilates Rings were designed to be faithful reproductions of Joseph Pilates' Magic Circles. Shop now."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    // CtaProdButton,
    TertiaryButton
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      show: false, // Intro content
      product: {
        label: "Select Resistance",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 41267959234753,
          partnumber: "720-021",
          price: 175,
          name: "Heavy, 4-band",
          available: true
        },
        {
          prodid: 41267959267521,
          partnumber: "720-022",
          price: 160,
          name: "Medium, 3-band",
          available: true
        },
        {
          prodid: 41267959300289,
          partnumber: "720-023",
          price: 145,
          name: "Light, 2-band",
          available: true
        },
      ]
    };
  },
  
  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.col-flex {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
}

.col-flex p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
  margin-bottom: 20px;
}

.col-flex img {
  width: 100%;
  max-width: 320px;
  max-height: 220px;
}

.resistance-image {
  width: 100%;
  max-width: 495px;
  order: 4;
}

@media only screen and (min-width: 600px) {
  .col-flex {
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
  }

  .col-flex p {
    padding-right: 20px;
    max-width: 470px;
    margin: 0;
  }

  .resistance-image {
    max-width: 100%;
  }
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .resistance-image {
    max-width: 530px;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  .col-flex {
    flex-flow: column nowrap;
    order: 5;
  }

  .col-flex p {
    margin-bottom: 30px;
  }

  .icon-link {
    margin: 0;
  }

  .more {
    order: 5;
    margin-top: 20px;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 550px auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 2;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 2 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .col-flex {
    grid-column: 2 / span 1;
    grid-row: 3 / span 1;
    align-items: flex-start;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
